export enum Ranks {
  Fondateur = 'Fondateur',
  Staff = 'Staff',
  Streamer = 'Streamer',
  VIP = 'VIP',
  Player = 'Player',
}
